import { DispatchEvent } from '@api/Trinium/Endpoints/DispatchEvent';

import styles from './DataGrid.DispatchEvent.module.css';

interface DispatchEventMobileItemProps {
	event: DispatchEvent;
}

export default function DispatchEventMobileItem({ event }: DispatchEventMobileItemProps) {
	return (
		<div className={styles['mobile-li']}>
			<div className={styles['event-type']}>
				<span>{event.eventType}</span>
			</div>
			<div className={styles.note}>
				<span>{event.note}</span>
			</div>
			<div className={styles['authored']}>
				<span>{`${event.userId} - ${event.userName}`}</span>
				<span>{event.eventDate?.date}</span>
			</div>
		</div>
	);
}
